export default {
    defaultExpVariant: 'a',
    'ROAD-32640': 'b',
    'ROAD-30217': 'b',
    'ROAD-75799': 'b',
    'ROAD-60278': 'ROAD-60278',
    'ROAD-31763': 'ROAD-31763'
    // ADD VARIANTS, IF ANY CORRESPONDING TO JIRA ID PATTERN: ROAD-XXXX: a|b|c
};
